// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__Q1xUP","paramInput":"JobSimulator_paramInput__1Q7Rl","input":"JobSimulator_input__3fIjh"};